import {
  byBreakpoints
} from "./chunk-JPXPBBHO.mjs";

// src/icon.tsx
import {
  InfoCheckCircle,
  InfoCircle,
  InfoWarning
} from "@teamsparta/stack-icons";
import { baseSemanticColor, primitiveColor } from "@teamsparta/stack-tokens";
import { jsx } from "@emotion/react/jsx-runtime";
var toastIconSizeVariants = {
  md: 20,
  lg: 24
};
function iconsByType({ type, size }) {
  switch (type) {
    case "info":
      return /* @__PURE__ */ jsx(
        InfoCircle,
        {
          size,
          style: "fill",
          color: primitiveColor.neutral[5]
        }
      );
    case "success":
      return /* @__PURE__ */ jsx(
        InfoCheckCircle,
        {
          size,
          style: "fill",
          color: baseSemanticColor.status.success.subtle
        }
      );
    case "warning":
      return /* @__PURE__ */ jsx(
        InfoWarning,
        {
          size,
          style: "fill",
          color: baseSemanticColor.status.warning.subtle
        }
      );
    case "error":
      return /* @__PURE__ */ jsx(
        InfoCircle,
        {
          size,
          style: "fill",
          color: baseSemanticColor.status.error.subtle
        }
      );
    case "basic":
    default:
      return null;
  }
}
function renderIcon({
  type,
  sizes
}) {
  const icons = sizes.map(({ breakpoint, size }) => ({
    node: iconsByType({ type, size: toastIconSizeVariants[size] }),
    breakpoint
  }));
  return byBreakpoints(icons);
}

export {
  renderIcon
};
